export const PORTAL_IDS = {
  locationDetailsNotifications: 'location-details-notifications',
  coverBtn: 'cover-btn-portal',
  coverSubtitle: 'cover-subtitle',
  coverBanner: 'cover-banner-portal',
};
